module.exports = __webpack_public_path__ + "img/group@3x.1a987301.jpg";